import { PropsWithChildren } from 'react';

/**
 * Wraps the content and header.  This is just to match the way figma is arranged.
 */
export const LuiModalAsyncMain = ({ children }: PropsWithChildren<unknown>) => (
  <div className={'LuiModalAsync-main'}>{children}</div>
);
